import React from 'react'
import classNames from 'classnames'
import { Select } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

const CustomSelect = ({ className, disabled, ...props }) => {
  return (
    <Select
      className={classNames('custom-select', { 'custom-select--disabled': disabled }, className, {
        'opacity-50': disabled,
      })}
      useReactSelect
      disabled={disabled}
      {...props}
    />
  )
}

export default CustomSelect
